import { Typography } from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";

export const TitleWithExpansion = ({
  setIsExpanded,
  isExpanded,
  title,
}: {
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  isExpanded: boolean;
  title: string;
}) => {
  return (
    <div onClick={() => setIsExpanded(!isExpanded)}>
      <Typography variant="h5" marginLeft="0.5em">
        {title}
        {isExpanded ? (
          <ExpandLessIcon style={{ marginLeft: "5px" }} />
        ) : (
          <ExpandMoreIcon style={{ marginLeft: "5px" }} />
        )}
      </Typography>
    </div>
  );
};
